import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
})
export class RadioButtonComponent {
  @Input() public control: AbstractControl;
  @Input() public modelField: any;
  @Input() public id: string;
  @Input() public label: string = '';
  @Input() public helper: string = '';
  @Input() public value: string | number | boolean;
  @Input() public classGroup: string = '';
  @Input() public name: string = '';
  @Input() public disabled: boolean = false;
  @Input() public hideLabel: boolean = false;
  @Input() public isSm: boolean = false;
  @Input() public tooltipData: string;
  @Output() public modelChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  public get controlPresented(): boolean {
    return !!this.control;
  }

  public get modelPresented(): boolean {
    return !isNaN(this.modelField);
  }
}
